import { render } from "./IngresoPresupuestos.vue?vue&type=template&id=6c8dc53c&scoped=true"
import script from "./IngresoPresupuestos.vue?vue&type=script&lang=js"
export * from "./IngresoPresupuestos.vue?vue&type=script&lang=js"

import "./IngresoPresupuestos.vue?vue&type=style&index=0&id=6c8dc53c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8dc53c"]])

export default __exports__